import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import T from 'src/components/content-manager/translator/T';
import { useNumberFormat } from 'src/core/hooks/format';
import VolumeDiscount from 'src/entities/volume-discount/VolumeDiscount';
import { getEntities } from 'src/store/entities/selectors';
import { EntityDescriptions } from 'src/store/entities/types';
import { EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';

const TABS = 'ARTICLE_GROUP_1111';
const BEANS = 'ARTICLE_GROUP_1112';

const VolumeDiscountSnippet: React.FC = () => {
    const volumeDiscounts: EntityCollectionState<VolumeDiscount> = useSelector(state =>
        getEntities(state, EntityDescriptions.VOLUME_DISCOUNT)
    );
    const formatNumber = useNumberFormat();

    const discounts = useMemo(
        () => volumeDiscounts.items.filter(d => [TABS, BEANS].includes(d.articleGroupNormalizedName)),
        [volumeDiscounts.items]
    );

    if (volumeDiscounts.items.length <= 0) return null;

    return (
        <T
            k="shop.volume_discount_discover.discount_from"
            options={{
                value: discounts
                    .map(d => {
                        const value = formatNumber({
                            postfix: d.baseColli,
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                        })(d.activePremiumLevelDiscounts.filter(pld => pld.value > 0)[0].minQuantity);

                        return `${value} ${d.articleGroupLocalizedName}`;
                    })
                    .join(' / '),
            }}
        />
    );
};

export default VolumeDiscountSnippet;
